import * as React from "react";
import { IconProps } from "./types";

const BellIcon = ({
  className,
  width = 24,
  height = 25,
  strokeWidth = 2,
}: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
  >
    <path
      d="M18 8.5a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9ZM13.73 21.5a1.999 1.999 0 0 1-3.46 0"
      stroke="inherit"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BellIcon;
